import Firebase from 'firebase'

// [DEFAULT]: Firebase: Firebase App named '[DEFAULT]' already exists (app/duplicate-app).
// let db
// if (Firebase.apps.length === 0) {}

// Initialize Firebase
let config = {
  apiKey: 'AIzaSyDNMLvPFnf1oDYWtvjD9shmlG2MGRKeyko',
  authDomain: 'setdancepal.firebaseapp.com',
  databaseURL: 'https://setdancepal.firebaseio.com',
  projectId: 'setdancepal',
  storageBucket: 'setdancepal.appspot.com',
  messagingSenderId: '550717283978'
}
let firebaseApp = Firebase.initializeApp(config)
let db = firebaseApp.database()

export default db



// WEBPACK FOOTER //
// ./src/db.js